// import { Col, Row } from 'antd';
import React, { useContext } from 'react';
// import { MdAccountBalance } from "react-icons/md";
import { Link, useOutletContext } from 'react-router-dom';
// import discussIcon from './utils/icons/discussIcon';
import inventory from './utils/icons/inventory.png';
import purchase from './utils/icons/purchase.png';
import accountingIcon from './utils/icons/accountingIcon.png';
import contacts from './utils/icons/image.png';
import sales from './utils/icons/sales.png';
import employee from './utils/icons/employee.png';
import expense from './utils/icons/expense.png';
import pos from './utils/icons/pos.png';
import { Col, Row } from 'antd';
import Header from './MainHeader';
import Axios from './utils/axios';
import AuthContext from './utils/AuthContext';




const MainUI = () => {
  const {user, signOut} = useContext(AuthContext);
  // console.log('Layout: ', user);

  const handleSignOut = async () => {
    try {
      const responseData = await signOut();
      alert(responseData);
      window.location.href = '/';
    }catch (err) {
      console.log(err);
    }
  };


  return (
    <div className='ui bg-gray-200'>
      <Header signOut={handleSignOut}/>
      <div className='container mx-auto' style={{maxWidth: '900px'}}>
        <Row>
          {user.access_right.accounting_role && 
            <Col md={{span: 5}}>
              <Link className=' hover:text-black flex flex-col items-center hover:shadow hover:bg-white' to={'/accounting'}>
                <img src={accountingIcon} alt="accounting icon" className='box-content'/>
                <span>Accounting</span>
              </Link>
            </Col>
          }
          {user.access_right.inventory_role && 
            <Col md={{span: 5}}>
              <Link className=' hover:text-black flex flex-col items-center hover:shadow hover:bg-white' to={'/inventory'}>
                <img src={inventory} alt="inventory icon"/>
                <span>Inventory</span>
              </Link>
            </Col>
          }
          {user.access_right.purchase_role && 
            <Col md={{span: 5}}>
              <Link className=' hover:text-black flex flex-col items-center hover:shadow hover:bg-white' to={'/purchase'}>
                <img src={purchase} alt="purchase icon"/>
                <span>Purchase</span>
              </Link>
            </Col>
          }
          {user.access_right.sales_role && 
            <Col md={{span: 5}}>
              <Link className=' hover:text-black flex flex-col items-center hover:shadow hover:bg-white' to={'/sales'}>
                <img src={sales} alt="sales icon" className="p-2" />
                <span>Sales</span>
              </Link>
            </Col>
          }
          {user.access_right.pos_role && 
            <Col md={{span: 5}}>
              <Link className=' hover:text-black flex flex-col items-center hover:shadow hover:bg-white' to={'/pos'}>
                <img src={pos} alt="sales icon" className="p-2" />
                <span>Point of Sales</span>
              </Link>
            </Col>
          }
          <Col md={{span: 5}}>
            <Link className=' hover:text-black flex flex-col items-center hover:shadow hover:bg-white' to={'/contact'}>
              <img src={contacts} alt="contacts icon" className="p-2" width={'100%'} height={'100%'}/>
              <span>Contacts</span>
            </Link>
          </Col>
          {user.access_right.employee_role && <Col md={{span: 5}}>
            <Link className=' hover:text-black flex flex-col items-center hover:shadow hover:bg-white' to={'/employee-app'}>
              <img src={employee} alt="contacts icon" className="p-2" />
              <span>Employees</span>
            </Link>
          </Col>}
          {user.access_right.expense_role && <Col md={{span: 5}}>
            <Link className='hover:text-black flex flex-col items-center hover:shadow hover:bg-white' to={'/expense'}>
              <img src={expense} alt="contacts icon" className="p-2" />
              <span>Expenses</span>
            </Link>
          </Col>}
          {user.access_right.settings === 1 && <Col md={{span: 5}}>
            <Link className=' hover:text-black flex flex-col items-center hover:shadow hover:bg-white' to={'/settings'}>
              <img src={sales} alt="sales icon" className="p-2" />
              <span>Settings</span>
            </Link>
          </Col>}
        </Row>
      </div>
    </div>
  )
}

export default MainUI;